import React, { Fragment, ReactNode } from 'react';
import { Modal, notification, Radio } from 'antd';

import { Appointment, fetchAppointments } from '../../api/fetchAppointmentsV3';
import moment, { Moment } from 'moment';
import { getMe, getVisitById } from '../../store/idbHandler';
import { renderToString } from 'react-dom/server';
import { AddPtModal } from '../../components/common/newaddpt/NewPatientModal';
import { Patient } from '../../store/types/patient';
import bookBusinessAppointment from '../../api/bookBusinessAppointment';
import fetchDoctorSchedule, { Schedule } from '../../api/fetchDoctorSchedule';
import { MyDoc } from '../../api/fetchMyProfile';
import ResourceAvatar from './ResourceAvatar';
import rescheduleAppointment from '../../api/rescheduleAppointment';
import AppointmentSelectedCard from './AppointmentSelectedCard';
import { onAppointmentAction } from '../AppointmentUtils';
import { APWithOptionalpatient } from '../Appointments';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { ThunkDispatch } from 'redux-thunk';
import { GlobalState } from '../../store/reducers';
import { Actions } from '../../store/actions';
import { GO_TO_PATIENTS_DETAILS } from '../../routes/paths';
import { toggleIframeActionDialog } from '../../store/actions/session';
import { BOOKING_SLUG } from '../../api/constants';
import { track } from '../../tracking';
import { getScheduleSlotDuration, setScheduleSlotDuration } from '../../store/localstorage';
import GlobalSearchModal from '../../components/globalsearch/GlobalSearchModal';
import { FULL_GENDER_CHARS, Gender, NewPatientLocationState } from '../NewPatient';
import CreateABHAModalSDK from '../../components/abha/CreateABHAModalSdk';
import { TProfileRecord } from '../../bridge/types';

type StateSchedule = Schedule;

type State = {
    appointments?: Appointment[];
    // view:
    //     | 'resourceTimeGridDay'
    //     | 'dayGridMonth'
    //     | 'timeGridWeek'
    //     | 'timeGridDay'
    //     | 'listWeek resourceTimeGridWeek'
    //     | 'resourceTimelineWeek'
    //     | 'resourceTimeGridDay';
    newEvent?: {
        start: Date;
        end: Date;
        docid: string;
    };
    searchPtVisible?: boolean;
    addPatientFormDataAfterAbha?: Patient;
    schedules?: {
        [docid: string]: StateSchedule;
    };
    slotDuration: number;
    selectedApt?: Appointment;
    htmlNode?: HTMLElement;
    addNewPtVisible?: boolean;
    addNewPtDefaultState?: NewPatientLocationState;
    newPatientViaAbha?: boolean;
    abhaFlow?: 'create_abha_with_mobile' | 'login_with_abha';
};

type Props = {
    dispatch: ThunkDispatch<GlobalState, null, Actions>;
    cId: string;
    resources: { id: string; title: string; extendedProps: { doc: MyDoc } }[];
    timeView: 'day' | 'week' | 'month';
    isFreeSlotOnly?: boolean;
    date: Moment;
};

type MyResource = {
    resourceId: string;
    resourceIds?: string[];
    start: string;
    end: string;
    title?: string;
    backgroundColor?: string;
    extendedProps?: { apt?: Appointment; type?: 'availableSlot' | 'blocked' };
    durationEditable?: boolean;
    display?: 'background' | 'auto' | undefined;
};

class ScheduleCalendar extends React.PureComponent<RouteComponentProps & Props, State> {
    state: State = {
        // startDate: moment().startOf('day').toISOString(),
        // endDate: moment().endOf('day').toISOString(),
        slotDuration: getScheduleSlotDuration(),
    };
    ec: undefined;

    toggleAddNew = (visible: boolean, defaultState?: NewPatientLocationState): void => {
        this.setState({
            addNewPtVisible: visible,
            addNewPtDefaultState: defaultState,
        });
    };

    onSlotDurationChange = (e: any): void => {
        this.setState({ slotDuration: parseInt(e.target.value) }, () => {
            this.refresh();
        });
        track('SCHEDULE_SLOT_DURATION_CHANGE', { slotDuration: e.target.value });
        setScheduleSlotDuration(parseInt(e.target.value));
    };

    getBackgroundColor = (apt?: Appointment): string => {
        if (apt?.status === 'CM' || apt?.status === 'CMNP') {
            return '#E8E8E8';
        } else if (apt?.stage === 'ONGOING') {
            return '#D1EDE1';
        }
        return '#D3DFFF';
    };

    getTextColor = (apt?: Appointment): string => {
        if (apt?.status === 'CM') {
            return '#484848';
        } else if (apt?.stage === 'ONGOING') {
            return '#0F6440';
        }
        return '#143999';
    };

    getIcon = (apt?: Appointment): ReactNode => {
        if (apt?.status === 'CM') {
            return (
                <svg
                    width="16"
                    height="16"
                    viewBox="0 0 16 16"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        d="M8 3.625C6.24219 3.625 4.64844 4.5625 3.75781 6.0625C2.89062 7.58594 2.89062 9.4375 3.75781 10.9375C4.64844 12.4609 6.24219 13.375 8 13.375C9.73438 13.375 11.3281 12.4609 12.2188 10.9375C13.0859 9.4375 13.0859 7.58594 12.2188 6.0625C11.3281 4.5625 9.73438 3.625 8 3.625ZM8 14.5C5.84375 14.5 3.875 13.375 2.79688 11.5C1.71875 9.64844 1.71875 7.375 2.79688 5.5C3.875 3.64844 5.84375 2.5 8 2.5C10.1328 2.5 12.1016 3.64844 13.1797 5.5C14.2578 7.375 14.2578 9.64844 13.1797 11.5C12.1016 13.375 10.1328 14.5 8 14.5ZM10.6484 7.39844L7.64844 10.3984C7.41406 10.6328 7.0625 10.6328 6.85156 10.3984L5.35156 8.89844C5.11719 8.6875 5.11719 8.33594 5.35156 8.125C5.5625 7.89062 5.91406 7.89062 6.14844 8.125L7.25 9.22656L9.85156 6.625C10.0625 6.39062 10.4141 6.39062 10.6484 6.625C10.8594 6.83594 10.8594 7.1875 10.6484 7.39844Z"
                        fill="#19A66A"
                    />
                </svg>
            );
        } else if (apt?.stage === 'ONGOING') {
            return (
                <svg
                    width="16"
                    height="16"
                    viewBox="0 0 16 16"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        d="M8 10.75C6.92188 10.75 5.9375 10.1875 5.39844 9.25C4.85938 8.32422 4.85938 7.1875 5.39844 6.25C5.9375 5.32422 6.92188 4.75 8 4.75C9.06641 4.75 10.0508 5.32422 10.5898 6.25C11.1289 7.1875 11.1289 8.32422 10.5898 9.25C10.0508 10.1875 9.06641 10.75 8 10.75Z"
                        fill="#0F6440"
                    />
                </svg>
            );
        } else if (apt?.stage === 'CK') {
            return (
                <svg
                    width="16"
                    height="16"
                    viewBox="0 0 16 16"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        d="M7.08594 11.8984C6.85156 12.1328 6.5 12.1328 6.28906 11.8984C6.05469 11.6875 6.05469 11.3359 6.28906 11.1016L8.32812 9.0625H2.5625C2.23438 9.0625 2 8.82812 2 8.5C2 8.19531 2.23438 7.9375 2.5625 7.9375H8.32812L6.28906 5.89844C6.05469 5.6875 6.05469 5.33594 6.28906 5.10156C6.5 4.89062 6.85156 4.89062 7.08594 5.10156L10.0859 8.125C10.2969 8.33594 10.2969 8.6875 10.0859 8.89844L7.08594 11.8984ZM10.0625 4.375C9.73438 4.375 9.5 4.14062 9.5 3.8125C9.5 3.50781 9.73438 3.25 10.0625 3.25H11.9375C13.0625 3.25 14 4.1875 14 5.3125V11.6875C14 12.8359 13.0625 13.75 11.9375 13.75H10.0625C9.73438 13.75 9.5 13.5156 9.5 13.1875C9.5 12.8828 9.73438 12.625 10.0625 12.625H11.9375C12.4531 12.625 12.875 12.2266 12.875 11.6875V5.3125C12.875 4.79688 12.4531 4.375 11.9375 4.375H10.0625Z"
                        fill="#143999"
                    />
                </svg>
            );
        }
        return (
            <svg
                width="16"
                height="16"
                viewBox="0 0 16 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    d="M6.3125 3.0625V4H9.6875V3.0625C9.6875 2.75781 9.92188 2.5 10.25 2.5C10.5547 2.5 10.8125 2.75781 10.8125 3.0625V4H11.75C12.5703 4 13.25 4.67969 13.25 5.5V5.875V7V13C13.25 13.8438 12.5703 14.5 11.75 14.5H4.25C3.40625 14.5 2.75 13.8438 2.75 13V7V5.875V5.5C2.75 4.67969 3.40625 4 4.25 4H5.1875V3.0625C5.1875 2.75781 5.42188 2.5 5.75 2.5C6.05469 2.5 6.3125 2.75781 6.3125 3.0625ZM3.875 7V13C3.875 13.2109 4.03906 13.375 4.25 13.375H11.75C11.9375 13.375 12.125 13.2109 12.125 13V7H3.875Z"
                    fill="#143999"
                />
            </svg>
        );
    };

    refresh = async (): Promise<void> => {
        const { isFreeSlotOnly, date, timeView } = this.props;
        const { slotDuration } = this.state;
        const aptResponse = await fetchAppointments(
            this.props.cId,
            moment(date).startOf(timeView).toISOString(),
            moment(date).endOf(timeView).toISOString(),
            this.props.resources.map((r) => r.id),
        );

        this.setState({ appointments: aptResponse.data?.apts || [] });

        const events: MyResource[] =
            aptResponse.data?.apts
                .filter(
                    (a) =>
                        ![
                            'CN',
                            'NS',
                            'NSD',
                            'NSS',
                            'RE',
                            'RED',
                            'CND',
                            'CNS',
                            'IN',
                            'AB',
                            'RES',
                        ].includes(a.status) && !a.archive,
                )
                .map((apt) => {
                    let endTime = apt.end_time;
                    if (!apt.end_time || apt.end_time === apt.start_time) {
                        // add 15 mins to start time and set end time
                        endTime = moment(apt.start_time)
                            .add(slotDuration, 'minutes')
                            .format('YYYY-MM-DD HH:mm');
                    } else {
                        endTime = moment(apt.end_time).format('YYYY-MM-DD HH:mm');
                    }
                    return {
                        resourceId: apt.doctor_oid,
                        start: moment(apt.start_time).format('YYYY-MM-DD HH:mm'),
                        end: endTime,
                        title: apt.patient?.fln || '',
                        backgroundColor: isFreeSlotOnly ? '#E8E8E8' : this.getBackgroundColor(apt),
                        extendedProps: { apt },
                        durationEditable: false,
                        startEditable: apt.status === 'BK',
                        display: isFreeSlotOnly ? 'background' : 'auto',
                    };
                }) || ([] as MyResource[]);

        this.props.resources.forEach((r) => {
            // for each day between start and end date
            const startDate = moment(this.props.date).startOf(timeView);
            const endDate = moment(this.props.date).endOf(timeView);
            for (let d = moment(startDate); d.isBefore(endDate); d.add(1, 'day')) {
                const schedule = (this.state.schedules || {})?.[r.id]?.[this.props.cId]?.[d.day()]
                    ?.bounds;
                if (!schedule || !schedule.length) {
                    const beEvent: MyResource = {
                        resourceId: r.id,
                        start: `${moment(d).format('YYYY-MM-DD')} 00:00`,
                        end: `${moment(d).format('YYYY-MM-DD')} 23:59`,
                        display: 'background',
                        backgroundColor: '#E8E8E8',
                        durationEditable: false,
                        title: 'BG',
                    };
                    events.push(beEvent);
                } else if (schedule && schedule.length) {
                    const bGEvents = getAvailableTimeBlocks(schedule);
                    bGEvents.forEach((e) => {
                        const beEvent: MyResource = {
                            resourceId: r.id,
                            start: `${moment(d).format('YYYY-MM-DD')} ${moment(
                                e.start,
                                'HHmm',
                            ).format('HH:mm')}`,
                            end: `${moment(d).format('YYYY-MM-DD')} ${moment(e.end, 'HHmm').format(
                                'HH:mm',
                            )}`,
                            display: 'background',
                            backgroundColor: '#E8E8E8',
                            durationEditable: false,
                            title: 'BG',
                            extendedProps: { apt: undefined, type: 'blocked' },
                        };

                        if (beEvent.end.endsWith('00:00')) {
                            beEvent.end = beEvent.end.replace('00:00', '23:59');
                        }

                        events.push(beEvent);
                    });

                    if (isFreeSlotOnly) {
                        const freeSlots = generateTimeSlots(schedule, slotDuration);
                        console.log('freeSlots', r.title, r.id, freeSlots);

                        freeSlots.forEach((e) => {
                            // Only add slot if endTime of slot is not passed yet
                            const endTime = `${moment(d).format('YYYY-MM-DD')} ${e.end}`;
                            if (moment().isAfter(moment(endTime))) {
                                return;
                            }

                            const beEvent: MyResource = {
                                resourceId: r.id,
                                start: `${moment(d).format('YYYY-MM-DD')} ${e.start}`,
                                end: endTime,
                                backgroundColor: '#D1EDE1',
                                display: 'auto',
                                // durationEditable: false,
                                // title: 'BG',
                                extendedProps: { apt: undefined, type: 'availableSlot' },
                            };

                            if (beEvent.end.endsWith('00:00')) {
                                beEvent.end = beEvent.end.replace('00:00', '23:59');
                            }
                            // if same resource as event with the same start time, then don't show the free slot

                            if (
                                events.find(
                                    (ev) =>
                                        ev.resourceId === beEvent.resourceId &&
                                        ev.start === beEvent.start,
                                )
                            ) {
                                return;
                            }
                            events.push(beEvent);
                        });
                    }
                }
            }
        });

        console.log('events', events);
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        this.ec?.setOption('events', events);
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        this.ec?.setOption('view', this.getView());
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        this.ec?.setOption('resources', this.props.resources); // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        this.ec?.setOption('slotDuration', `00:${slotDuration}:00`);
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        this.ec?.setOption('resourceLabelContent', (o) => this.resourceLabelContent(o));

        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        this.ec?.setOption('date', moment(this.props.date).format('YYYY-MM-DD'));
    };

    getView = ():
        | 'resourceTimelineDay'
        | 'timeGridDay'
        | 'resourceTimeGridDay'
        | 'dayGridMonth'
        | 'timeGridWeek'
        | 'resourceTimeGridWeek'
        | 'resourceTimelineMonth'
        | 'resourceTimelineWeek' => {
        if (this.props.resources.length === 1) {
            switch (this.props.timeView) {
                case 'day':
                    return 'timeGridDay';
                case 'week':
                    return 'timeGridWeek';
                case 'month':
                    return 'dayGridMonth';
            }
        } else {
            switch (this.props.timeView) {
                case 'day':
                    // return 'resourceTimelineDay';
                    return 'resourceTimeGridDay';
                case 'week':
                    // return 'resourceTimelineWeek';
                    return 'resourceTimeGridWeek';
                case 'month':
                    return 'dayGridMonth';
            }
        }
    };

    componentDidUpdate(
        prevProps: Readonly<Props>,
        prevState: Readonly<State>,
        snapshot?: any,
    ): void {
        if (
            prevProps.timeView !== this.props.timeView ||
            prevProps.cId !== this.props.cId ||
            prevProps.resources !== this.props.resources ||
            prevProps.isFreeSlotOnly !== this.props.isFreeSlotOnly ||
            prevProps.date !== this.props.date
        ) {
            this.refresh();
        }
    }

    // static getDerivedStateFromProps(nextProps: Props, prevState: State): State {
    //     if (nextProps.date) {
    //         return {
    //             ...prevState,
    //             startDate: nextProps.date.startOf('day').toISOString(),
    //             endDate: nextProps.date.endOf('day').toISOString(),
    //         };
    //     }
    //     return prevState;
    // }

    async fetchSchedule(): Promise<void> {
        const schedules: StateSchedule = {};
        for (const { id } of this.props.resources) {
            const scheduleResponse = await fetchDoctorSchedule({ docId: id });
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            schedules[id] = scheduleResponse.data?.schedule;
        }
        this.setState({ schedules });
    }

    onAppointmentViewDetials = (aid: string, manage?: boolean): void => {
        this.props.dispatch(
            toggleIframeActionDialog(
                `${BOOKING_SLUG}/appointment/${aid}${manage ? '?manage=true' : ''}`,
            ),
        );
    };

    onAppointmentAction = async (apt: APWithOptionalpatient): Promise<void> => {
        onAppointmentAction(this, apt, apt?.clinic_id);
        track('SCHEDULE_APPOINTMENT_ACTION', { status: apt.status, stage: apt.stage });
    };

    goToPatientDetails = (patient: Patient): void => {
        this.props.history.push(GO_TO_PATIENTS_DETAILS(patient.localId, 'visit'));
        track('SCHEDULE_GO_TO_PATIENT_DETAILS', { patientId: patient.localId });
    };

    resourceLabelContent = (o: {
        resource: { id: string; title: string; extendedProps: { doc: MyDoc } };
    }) => {
        const ongoingAptCount = this.state.appointments?.filter(
            (a) => a.doctor_oid === o.resource.id && a.stage === 'ONGOING',
        ).length;

        const bookedAptCount = this.state.appointments?.filter(
            (a) => a.doctor_oid === o.resource.id && a.status === 'BK',
        ).length;

        const followUpAptCount = this.state.appointments?.filter(
            (a) => a.doctor_oid === o.resource.id && a.status === 'IN',
        ).length;

        const completedAptCount = this.state.appointments?.filter(
            (a) => a.doctor_oid === o.resource.id && (a.status === 'CM' || a.status === 'CMNP'),
        ).length;

        return {
            html: renderToString(
                <div className="flex flex-col p-8 space-x-8 justify-center w-full">
                    <span className="flex space-x-8">
                        <ResourceAvatar resource={o.resource} size={24} />
                        <span
                            style={{ display: 'inline-block' }}
                            className="font-700 text-13 truncate text-neutral-black"
                        >
                            {o.resource.title}
                        </span>
                    </span>
                    <span
                        className="flex space-x-12 items-center"
                        style={{ marginLeft: 32, marginTop: -8 }}
                    >
                        {ongoingAptCount ? (
                            <span
                                className="flex space-x-4 items-center"
                                title="Ongoing appointment"
                            >
                                <span>
                                    <svg
                                        width="12"
                                        height="11"
                                        viewBox="0 0 12 11"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                    >
                                        <path
                                            d="M5.08594 8.89844C4.85156 9.13281 4.5 9.13281 4.28906 8.89844C4.05469 8.6875 4.05469 8.33594 4.28906 8.10156L6.32812 6.0625H0.5625C0.234375 6.0625 0 5.82812 0 5.5C0 5.19531 0.234375 4.9375 0.5625 4.9375H6.32812L4.28906 2.89844C4.05469 2.6875 4.05469 2.33594 4.28906 2.10156C4.5 1.89062 4.85156 1.89062 5.08594 2.10156L8.08594 5.125C8.29688 5.33594 8.29688 5.6875 8.08594 5.89844L5.08594 8.89844ZM8.0625 1.375C7.73438 1.375 7.5 1.14062 7.5 0.8125C7.5 0.507812 7.73438 0.25 8.0625 0.25H9.9375C11.0625 0.25 12 1.1875 12 2.3125V8.6875C12 9.83594 11.0625 10.75 9.9375 10.75H8.0625C7.73438 10.75 7.5 10.5156 7.5 10.1875C7.5 9.88281 7.73438 9.625 8.0625 9.625H9.9375C10.4531 9.625 10.875 9.22656 10.875 8.6875V2.3125C10.875 1.79688 10.4531 1.375 9.9375 1.375H8.0625Z"
                                            fill="#767676"
                                        />
                                    </svg>
                                </span>
                                <span>{ongoingAptCount}</span>
                            </span>
                        ) : null}
                        {bookedAptCount ? (
                            <span
                                className="flex space-x-4 items-center"
                                title="Booked appointment"
                            >
                                <span>
                                    <svg
                                        width="16"
                                        height="16"
                                        viewBox="0 0 16 16"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                    >
                                        <path
                                            d="M6.3125 3.0625V4H9.6875V3.0625C9.6875 2.75781 9.92188 2.5 10.25 2.5C10.5547 2.5 10.8125 2.75781 10.8125 3.0625V4H11.75C12.5703 4 13.25 4.67969 13.25 5.5V5.875V7V13C13.25 13.8438 12.5703 14.5 11.75 14.5H4.25C3.40625 14.5 2.75 13.8438 2.75 13V7V5.875V5.5C2.75 4.67969 3.40625 4 4.25 4H5.1875V3.0625C5.1875 2.75781 5.42188 2.5 5.75 2.5C6.05469 2.5 6.3125 2.75781 6.3125 3.0625ZM3.875 7V13C3.875 13.2109 4.03906 13.375 4.25 13.375H11.75C11.9375 13.375 12.125 13.2109 12.125 13V7H3.875Z"
                                            fill="#767676"
                                        />
                                    </svg>
                                </span>
                                <span>{bookedAptCount}</span>
                            </span>
                        ) : null}
                        {followUpAptCount ? (
                            <span
                                className="flex space-x-4 items-center"
                                title="Followup appointment"
                            >
                                <span>
                                    <svg
                                        width="13"
                                        height="13"
                                        viewBox="0 0 13 13"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                    >
                                        <path
                                            d="M1.51562 7.0625C1.21094 7.0625 0.976562 6.78125 1 6.47656V6.28906C1.11719 3.99219 3.01562 2.1875 5.3125 2.1875H8.125V1.34375C8.125 0.875 8.47656 0.5 8.94531 0.5C9.15625 0.5 9.34375 0.59375 9.50781 0.734375L11.3125 2.35156C11.4297 2.44531 11.5 2.60938 11.5 2.75C11.5 2.91406 11.4297 3.07812 11.3125 3.17188L9.50781 4.78906C9.34375 4.92969 9.15625 5 8.94531 5C8.5 5 8.125 4.625 8.125 4.17969V3.3125H5.3125C3.60156 3.3125 2.21875 4.64844 2.125 6.35938V6.54688C2.10156 6.85156 1.84375 7.08594 1.51562 7.0625ZM9.25 3.52344L10.0938 2.75L9.25 2V3.52344ZM12.4609 5.9375C12.7656 5.96094 13 6.21875 13 6.54688L12.9766 6.73438C12.8594 9.03125 10.9609 10.8125 8.66406 10.8125H5.875V11.6797C5.875 12.125 5.5 12.5 5.03125 12.5C4.82031 12.5 4.63281 12.4297 4.46875 12.2891L2.66406 10.6719C2.54688 10.5781 2.5 10.4141 2.5 10.2734C2.5 10.1094 2.54688 9.94531 2.66406 9.85156L4.46875 8.23438C4.63281 8.09375 4.82031 8.02344 5.03125 8.02344C5.5 8.02344 5.875 8.39844 5.875 8.84375V9.6875H8.66406C10.375 9.6875 11.7812 8.375 11.8516 6.66406L11.875 6.47656C11.875 6.17188 12.1328 5.9375 12.4609 5.9375ZM4.75 9.5L3.88281 10.25L4.75 11.0234V9.5Z"
                                            fill="#767676"
                                        />
                                    </svg>
                                </span>
                                <span>{followUpAptCount}</span>
                            </span>
                        ) : null}
                        {completedAptCount ? (
                            <span
                                className="flex space-x-2 items-center"
                                title="Completed appointment"
                            >
                                <span>
                                    <svg
                                        width="16"
                                        height="16"
                                        viewBox="0 0 16 16"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                    >
                                        <path
                                            d="M8 3.625C6.24219 3.625 4.64844 4.5625 3.75781 6.0625C2.89062 7.58594 2.89062 9.4375 3.75781 10.9375C4.64844 12.4609 6.24219 13.375 8 13.375C9.73438 13.375 11.3281 12.4609 12.2188 10.9375C13.0859 9.4375 13.0859 7.58594 12.2188 6.0625C11.3281 4.5625 9.73438 3.625 8 3.625ZM8 14.5C5.84375 14.5 3.875 13.375 2.79688 11.5C1.71875 9.64844 1.71875 7.375 2.79688 5.5C3.875 3.64844 5.84375 2.5 8 2.5C10.1328 2.5 12.1016 3.64844 13.1797 5.5C14.2578 7.375 14.2578 9.64844 13.1797 11.5C12.1016 13.375 10.1328 14.5 8 14.5ZM10.6484 7.39844L7.64844 10.3984C7.41406 10.6328 7.0625 10.6328 6.85156 10.3984L5.35156 8.89844C5.11719 8.6875 5.11719 8.33594 5.35156 8.125C5.5625 7.89062 5.91406 7.89062 6.14844 8.125L7.25 9.22656L9.85156 6.625C10.0625 6.39062 10.4141 6.39062 10.6484 6.625C10.8594 6.83594 10.8594 7.1875 10.6484 7.39844Z"
                                            fill="#767676"
                                        ></path>
                                    </svg>
                                </span>
                                <span>{completedAptCount}</span>
                            </span>
                        ) : null}
                    </span>
                </div>,
            ),
        };
    };

    async componentDidMount(): Promise<void> {
        const { slotDuration } = this.state;
        await this.fetchSchedule();
        this.refresh();

        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        this.ec = new EventCalendar(document.getElementById('ec'), {
            view: this.getView(),
            allDaySlot: false,
            // datesSet: this.onDateChange,
            headerToolbar: {
                start: '',
                center: '',
                end: '',
            },
            scrollTime: moment().subtract(1, 'hour').format('HH:MM:SS'),
            slotMinTime: '08:00',
            slotMaxTime: '23:00',
            // events,
            eventClick: async (info: { event: MyResource }) => {
                console.log('eventClick', info);
                track('SCHEDULE_EVENT_CLICK', {
                    aid: info.event.extendedProps?.apt?.aid,
                    type: info.event.extendedProps?.type,
                });
                if (info.event.extendedProps?.type === 'availableSlot') {
                    if (info.event.resourceIds?.[0]) {
                        this.setState({
                            newEvent: {
                                start: new Date(info.event.start),
                                end: new Date(info.event.end),
                                docid: info.event.resourceIds?.[0] || this.props.resources[0].id,
                            },
                            searchPtVisible: true,
                        });
                    }
                } else {
                    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                    // @ts-ignore
                    console.log('eventClick', info, info.jsEvent.target);
                    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                    // @ts-ignore
                    const apt: Appointment & { isLocalPresnt: boolean; localRxId?: string } = {
                        ...info.event.extendedProps?.apt,
                        isLocalPresnt: false,
                        localRxId: undefined,
                    };
                    const localVisit = await getVisitById(apt.aid);
                    if (localVisit) {
                        apt.isLocalPresnt = true;
                        apt.localRxId = localVisit?.prescriptionId;
                    }
                    if (apt) {
                        this.setState({
                            selectedApt: apt,
                            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                            // @ts-ignore
                            htmlNode: info.jsEvent.target,
                        });
                        const screenWidth = window.screen.width;
                        const screenHeight = window.screen.height;
                        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                        // @ts-ignore
                        const rect = info.jsEvent.target.getBoundingClientRect();
                        console.log('rect', rect);
                        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                        // @ts-ignore
                        const dialogXPosition = info.jsEvent.x - screenWidth / 2;
                        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                        // @ts-ignore
                        const dialogYPosition = info.jsEvent.y + 20;
                        console.log('dialogXPosition', dialogXPosition, dialogYPosition);

                        const { top, left } = calculateDialogPosition(
                            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                            // @ts-ignore
                            info.jsEvent.x,
                            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                            // @ts-ignore
                            info.jsEvent.y,
                            416,
                            237,
                        );
                        const t = Modal.info({
                            title: 'Appointment Details',
                            closable: true,
                            maskClosable: true,
                            mask: false,
                            style: {
                                top,
                                left,
                            },
                            modalRender: () => {
                                return (
                                    <AppointmentSelectedCard
                                        apt={apt}
                                        resource={
                                            this.props.resources.find(
                                                (r) => r.id === info.event.resourceIds?.[0],
                                            ) || this.props.resources[0]
                                        }
                                        closeMe={(shouldRefresh?: boolean) => {
                                            t.destroy();
                                            if (shouldRefresh) {
                                                this.refresh();
                                            }
                                        }}
                                        onAppointmentAction={() => {
                                            this.onAppointmentAction(apt);
                                            t.destroy();
                                        }}
                                        goToPatientDetails={(patient: Patient) => {
                                            this.goToPatientDetails(patient);
                                            t.destroy();
                                        }}
                                    />
                                );
                            },
                            onOk: () => {
                                this.setState({ selectedApt: undefined, htmlNode: undefined });
                            },
                        });

                        // alert(
                        //     apt?.patient?.fln +
                        //         ' ' +
                        //         apt.patient?.mobile +
                        //         ' ' +
                        //         moment(apt.start_time).format('hh:mm A') +
                        //         ' ' +
                        //         moment(apt.end_time).format('hh:mm A'),
                        // );
                    }
                }
            },
            select: (info: {
                start: Date;
                end: Date;
                startStr: string;
                endStr: string;
                allDay: boolean;
                jsEvent: Event;
                // view: a;
                resource: { id: string };
            }) => {
                track('SCHEDULE_SLOT_SELECT', {
                    start: info.startStr,
                    end: info.endStr,
                });

                if (moment(info.start).isBefore(moment())) {
                    notification.error({
                        message: 'Cannot select past time',
                        description: 'Please select future time',
                    });
                    return;
                }
                this.setState({
                    newEvent: {
                        start: info.start,
                        end: info.end,
                        // in case of single doctor, it's a non resource view, and the library doesn't give the resource id
                        docid: info.resource?.id || this.props.resources[0].id,
                    },
                    searchPtVisible: true,
                });
            },

            slotDuration: `00:${slotDuration}:00`,
            eventContent: (o: { event: MyResource }) => {
                if (o.event?.extendedProps?.type === 'availableSlot') {
                    return {
                        html: renderToString(
                            <div
                                className="space-x-8"
                                style={{
                                    color: '#0F6440',
                                    border: '0.1px dashed #0F6440',
                                }}
                            >
                                <span className="flex space-x-4">
                                    {/* <span>{this.getIcon(o.event.extendedProps.apt)}</span> */}
                                    <p className="font-600">
                                        {moment(o.event.start).format('hh:mm A')}
                                    </p>
                                </span>
                                {/* <p className="font-600">
                                {moment(o.event.extendedProps.apt.start_time).format('hh:mm A')} -{' '}
                                {moment(o.event.extendedProps.apt.end_time).format('hh:mm A')}
                            </p> */}
                            </div>,
                        ),
                    };
                } else if (o.event?.extendedProps?.type === 'blocked') {
                    return {
                        html: renderToString(
                            <div
                                className="space-x-8"
                                style={{
                                    color: '#0F6440',
                                    border: '0.1px dashed #0F6440',
                                }}
                            >
                                <span className="flex space-x-4">
                                    {/* <span>{this.getIcon(o.event.extendedProps.apt)}</span> */}
                                    <p className="font-600"></p>
                                </span>
                                {/* <p className="font-600">
                                {moment(o.event.extendedProps.apt.start_time).format('hh:mm A')} -{' '}
                                {moment(o.event.extendedProps.apt.end_time).format('hh:mm A')}
                            </p> */}
                            </div>,
                        ),
                    };
                }
                if (
                    !o?.event?.extendedProps?.apt ||
                    (this.props.isFreeSlotOnly && o?.event?.extendedProps?.apt)
                ) {
                    return undefined;
                }
                return {
                    html: renderToString(
                        <div
                            className="space-x-8"
                            style={{
                                backgroundColor: this.getBackgroundColor(o.event.extendedProps.apt),
                                color: this.getTextColor(o.event.extendedProps.apt),
                            }}
                        >
                            <span className="flex space-x-4">
                                <span>{this.getIcon(o.event.extendedProps.apt)}</span>
                                <p className="font-600">{o.event.extendedProps.apt.patient?.fln}</p>
                            </span>
                            {/* <p className="font-600">
                                {moment(o.event.extendedProps.apt.start_time).format('hh:mm A')} -{' '}
                                {moment(o.event.extendedProps.apt.end_time).format('hh:mm A')}
                            </p> */}
                        </div>,
                    ),
                };
            },
            resourceLabelContent: this.resourceLabelContent,
            dayMaxEvents: true,
            nowIndicator: true,
            selectable: true,
            views: {
                resourceTimelineWeek: {
                    slotDuration: '01:00:00',
                    nowIndicator: true,
                },
            },
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            dateClick: (info) => {
                track('SCHEDULE_SLOT_CLICK', {
                    start: info.dateStr,
                });
                if (info?.jsEvent?.target?.classList.contains('ec-bg-event')) {
                    // Click on a background event
                    info?.jsEvent.preventDefault();
                    info.jsEvent.stopPropagation();
                } else {
                    const newEvent = {
                        start: info.start || info.date,
                        end: info.end || info.date,
                        docid: info.resource?.id || this.props.resources[0].id,
                    };

                    if (newEvent.start === newEvent.end) {
                        newEvent.end = moment(newEvent.start).add(slotDuration, 'minutes').toDate();
                    }
                    this.setState({
                        newEvent,
                    });
                }
            },
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            eventDrop: (info) => {
                track('SCHEDULE_EVENT_DROP', {
                    aid: info.event.extendedProps?.apt?.aid,
                    start: info.event.start.toISOString(),
                    end: info.event.end.toISOString(),
                });
                const { event, oldEvent, oldResource, newResource, revert } = info;
                const doctorId = newResource?.id || this.props.resources[0].id;
                const doctorResource = this.props.resources.find((r) => r.id === doctorId);
                rescheduleAppointment({
                    payload: {
                        aid: event.extendedProps.apt.aid,
                        start_time: event.start.toISOString(),
                        end_time: event.end.toISOString(),
                        clinic_id: this.props.cId,
                        mode: 'in-clinic',
                        doctor_to_change_to_oid: newResource?.id || this.props.resources[0].id,
                    },
                    meta: 'Doctor',
                })
                    .then((res) => {
                        if (!res.success) {
                            throw new Error(res.error);
                        }
                        this.refresh();
                        notification.success({
                            message: 'Appointment rescheduled',
                        });
                    })
                    .catch((e) => {
                        console.error('rescheduleAppointment', e);
                        notification.error({
                            message:
                                'Failed to reschedule appointment, please check the schedule/calendar setup',
                        });
                        revert();
                    });
            },
        });
    }

    closeAddNewEvent = (): void => {
        this.setState({
            newEvent: undefined,
            searchPtVisible: false,
            addNewPtVisible: false,
            addPatientFormDataAfterAbha: undefined,
        });
    };

    closeSearchPt = (): void => {
        this.setState({ searchPtVisible: undefined });
    };

    onPatientAdd = (patient: Patient): void => {
        track('SCHEDULE_ADD_PATIENT', { patientId: patient.localId });
        console.log('onPatientAdd', patient);
        const { newEvent } = this.state;
        if (!newEvent || !newEvent.start || !newEvent.docid || !newEvent.end) {
            return;
        }
        bookBusinessAppointment({
            start_time: newEvent.start.toISOString(),
            end_time: newEvent.end.toISOString(),
            patient: {
                oid: patient.id || patient.localId,
            },
            channel: 'Doctor',
            docId: newEvent.docid,
            clinic_id: this.props.cId,
            action: 'BK',
            mode: 'in-clinic',
            tags: [],
        })
            .then((res) => {
                console.log('bookBusinessAppointment', res);
                this.refresh();
                if (!res.success) {
                    throw new Error(res.error);
                }
            })
            .catch((e) => {
                console.error('bookBusinessAppointment', e);
                alert('Failed to book appointment');
            });
        // this.closeAddNewEvent();
        // this.refresh();
    };

    toggleAddPtDialogViaAbha = (
        value: boolean,
        state?: NewPatientLocationState,
        flow?: 'create_abha_with_mobile' | 'login_with_abha',
    ): void => {
        this.setState({
            newPatientViaAbha: value,
            addNewPtDefaultState: state,
            abhaFlow: flow,
        });
    };

    closeNewPatientViaAbha = (): void => {
        this.setState({
            newPatientViaAbha: false,
        });
    };

    onSucessAddPatientByAbha = (profile?: TProfileRecord): void => {
        console.log('onSucessAddPatientByAbha', profile);
        if (!profile) {
            track('ERROR', {
                on: 'abha',
                what: 'add-patient',
                status: 'failed',
                message: 'Profile not found',
            });
            notification.error({
                message: 'Profile not found',
                duration: 5,
            });
            return;
        }

        this.setState({
            addPatientFormDataAfterAbha: {
                id: profile.oid,
                localId: profile.oid,
                personal: {
                    name: {
                        f: profile.fln,
                    },
                    phone: {
                        c: '+91',
                        n: profile.mobile?.replace('+91', ''),
                    },
                    gender: FULL_GENDER_CHARS[profile.gen || ''],
                    age: {
                        dob: profile.dob,
                    },
                },
                abha: {
                    id: profile['health-ids']?.[0],
                },
            },
        });
    };

    render(): JSX.Element {
        const {
            newEvent,
            slotDuration,
            selectedApt,
            htmlNode,
            addNewPtVisible,
            addNewPtDefaultState,
            newPatientViaAbha,
            abhaFlow,
            searchPtVisible,
            addPatientFormDataAfterAbha,
        } = this.state;
        return (
            <Fragment>
                {newEvent && searchPtVisible && (
                    <GlobalSearchModal
                        isGlobalSearchVisible={true}
                        close={this.closeSearchPt}
                        onSelectPatient={this.onPatientAdd}
                        onAddPatient={(state: NewPatientLocationState) =>
                            this.toggleAddNew(true, state)
                        }
                        onAddPatientViaAbha={(
                            state: NewPatientLocationState,
                            flow?: 'create_abha_with_mobile' | 'login_with_abha',
                        ) => this.toggleAddPtDialogViaAbha(true, state, flow)}
                    />
                )}
                {addNewPtVisible && newEvent && (
                    <AddPtModal
                        initialState={addNewPtDefaultState}
                        // TODO: check if this is needed
                        defaultFormState={'add-pt'}
                        close={this.closeAddNewEvent}
                        // TODO: check if this is needed
                        isAbhaNewFlow={false}
                        docid={newEvent.docid}
                        style={{ zIndex: 10001, position: 'absolute' }}
                        callback={this.onPatientAdd}
                        topContent={
                            <div className="flex justify-between items-center px-24 py-16 bg-status-successBG">
                                <p className="text-neutral-3 font-700">
                                    Slot: {moment(newEvent.start).format('DD/MM hh:mm a')} -{' '}
                                    {moment(newEvent.end).format('DD/MM hh:mm a')}
                                </p>
                            </div>
                        }
                        cId={this.props.cId}
                    />
                )}
                {newPatientViaAbha && (
                    <CreateABHAModalSDK
                        onClose={this.closeNewPatientViaAbha}
                        mobile={addNewPtDefaultState?.phoneNumber}
                        onComplete={this.onSucessAddPatientByAbha}
                        method={abhaFlow || 'create_abha_with_mobile'}
                    />
                )}

                {newEvent && addPatientFormDataAfterAbha && (
                    <AddPtModal
                        initialState={{
                            name: addPatientFormDataAfterAbha.personal.name.f,
                            phoneNumber: addPatientFormDataAfterAbha.personal.phone?.n,
                            gender: addPatientFormDataAfterAbha.personal.gender as Gender,
                            dob: addPatientFormDataAfterAbha.personal.age?.dob,
                        }}
                        defaultFormState={'add-pt'}
                        close={this.closeAddNewEvent}
                        isAbhaNewFlow={true}
                        docid={newEvent.docid}
                        cId={this.props.cId}
                        defaultShowAbhaCard
                        defaultAbhaId={addPatientFormDataAfterAbha.abha?.id}
                        defaultAbhaPtOid={addPatientFormDataAfterAbha.id}
                    />
                )}
                {/* {selectedApt && htmlNode && (
                    <AppointmentSelectedCard apt={selectedApt} htmlNode={htmlNode} />
                )} */}
                <div className="flex flex-col overflow-hidden h-full">
                    <div className="flex space-x-8 m-8 items-center justify-between">
                        <div className="flex space-x-8">
                            {/* <span className="font-700">{this.getTitle()}</span> */}
                        </div>
                        <div className="flex space-x-8 items-center">
                            <span className="font-600">Slot duration:</span>
                            <Radio.Group
                                defaultValue={slotDuration.toString()}
                                buttonStyle="solid"
                                onChange={this.onSlotDurationChange}
                            >
                                <Radio.Button value="2">2 mins</Radio.Button>
                                <Radio.Button value="3">3 mins</Radio.Button>
                                <Radio.Button value="5">5 mins</Radio.Button>
                                <Radio.Button value="10">10 mins</Radio.Button>
                                <Radio.Button value="15">15 mins</Radio.Button>
                                <Radio.Button value="20">20 mins</Radio.Button>
                            </Radio.Group>
                        </div>
                    </div>
                    <div id="ec" className="overflow-hidden h-full"></div>
                </div>
            </Fragment>
        );
    }
}

export default connect()(withRouter(ScheduleCalendar));
export { ScheduleCalendar };

interface TimeBlock {
    e: number; // End time
    // conf_ids: string[]; // Conference IDs
    s: number; // Start time
}

interface Event {
    start: string;
    end: string;
    display: 'background';
}

function formatTime(time: number): string {
    const hours = Math.floor(time / 100);
    const minutes = time % 100;
    return `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}`;
}

function getAvailableTimeBlocks(events: TimeBlock[]): Event[] {
    const fullDayStart = 0;
    const fullDayEnd = 2400;

    // Sort events by start time
    const sortedEvents = events.sort((a, b) => a.s - b.s);

    const result: Event[] = [];
    let lastEnd = fullDayStart;

    for (const event of sortedEvents) {
        // If there's a gap between lastEnd and current event start, add an available time block
        if (event.s > lastEnd) {
            result.push({
                start: formatTime(lastEnd),
                end: formatTime(event.s),
                display: 'background',
            });
        }
        // Update lastEnd to be the maximum of the current lastEnd and event end time
        lastEnd = Math.max(lastEnd, event.e);
    }

    // Check for time after the last event until the end of the day
    if (lastEnd < fullDayEnd) {
        result.push({
            start: formatTime(lastEnd),
            end: formatTime(fullDayEnd),
            display: 'background',
        });
    }

    return result;
}

function formatTime24(time: number): string {
    const hours = Math.floor(time / 100);
    const mins = time % 100;
    return `${String(hours).padStart(2, '0')}:${String(mins).padStart(2, '0')}`;
}

function generateTimeSlots(events: TimeBlock[], slotTime: number = 5): Event[] {
    const timeSlots: Event[] = [];

    events.forEach((event) => {
        const { s: startTime, e: endTime } = event;
        let currentSlotStart = startTime;

        // Loop through time blocks based on slotTime (converting time from "HHmm" format)
        while (currentSlotStart < endTime) {
            // Calculate the end of the current slot
            let currentSlotEnd = currentSlotStart + slotTime;
            // Adjust hours if minutes overflow beyond 60
            if (currentSlotEnd % 100 >= 60) {
                currentSlotEnd += 40; // move to next hour
            }

            // Push the current slot into the array
            timeSlots.push({
                start: formatTime24(currentSlotStart),
                end: formatTime24(Math.min(currentSlotEnd, endTime)), // Ensure we don't exceed endTime
                display: 'background',
            });

            // Move to the next time slot
            currentSlotStart = currentSlotEnd;
        }
    });
    return timeSlots;
}

const calculateDialogPosition = (
    clickX: number,
    clickY: number,
    dialogWidth: number,
    dialogHeight: number,
): { top: number; left: number } => {
    const viewportWidth = window.innerWidth;
    const viewportHeight = window.innerHeight;

    // Calculate the initial position
    let left = clickX / 2 - dialogWidth / 2;
    let top = clickY + 20;

    // Adjust horizontal position if it goes out of bounds
    if (left + dialogWidth > viewportWidth) {
        left = viewportWidth - dialogWidth;
    }

    // Adjust vertical position if it goes out of bounds
    if (top + dialogHeight > viewportHeight) {
        top = viewportHeight - dialogHeight - 36;
    }
    if (top < 0) {
        top = 0;
    }

    return { top, left };
};
